import { FC, ReactElement } from "react";

const Sort:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path d="M4 17.313v-2.625h16v2.625h-16zM4 8h24v2.688h-24v-2.688zM4 24v-2.688h8v2.688h-8z"></path>
        </svg>
    )
}

export default Sort;